import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type JiraHomeType from '@atlassian/jira-spa-apps-jira-home/src/index.tsx';
import { YourWorkRedirect } from './YourWorkRedirect.tsx';

export const LazyJiraHomePage = lazyForPaint<typeof JiraHomeType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jira-home", jiraSpaEntry: "async-jira-home" */ '@atlassian/jira-spa-apps-jira-home'
		),
	),
);

/**
 * This component is used to conditionally render the Jira Home page for the "Your work" route.
 * It checks if the feature gate is enabled, then redirects to the "For you" route.
 * Otherwise, it renders the LazyJiraHomePage component like it normally would.
 *
 * @returns The Jira Home page or the YourWorkRedirect component.
 */
export const ConditionalJiraHome = () => {
	return fg('blu-7514_update_jira_home_your_work_to_for_you') ? (
		<YourWorkRedirect />
	) : (
		<LazyPage Page={LazyJiraHomePage} pageId="jira-home" shouldShowSpinner={false} />
	);
};
